// src/pages/Home.jsx
import React from "react";
import Hero from "../components/Hero";
import {
  CategoriesSection,
} from "../components/ProductCategories";
import MarqueeFlags from "../components/TargetCountries";
import Benefits from "../components/Benefits";
import Testimonials from "../components/Testimonials";
// import OurAchievements from "../components/OurAchievements";
import Collection from "../components/Collection";

import VermiComposeImage from "../assets/images/HomePoster1.svg";
import PowderImage from "../assets/images/Cover_Photo2.png";
import WhyChooseUs from "../components/WhyChooseUs";
import OurSuccess from "../components/OurSuccess";
import { FaCheckCircle } from "react-icons/fa";


const Home = () => {
  return (
    <>
      <Hero />
      {/* <h3 className="text-3xl md:text-4xl font-extrabold text-[#4b2e19] text-center mt-10 drop-shadow-sm">
        SHOP BY CATEGORY
      </h3> */}

      <CategoriesSection isHome={true} />
{/* --- Vermicompost Section --- */}
<Benefits
  image={VermiComposeImage}
  imageAlt="Vermicompost"
  imagePosition="right"
  heading="🌿 Organic Growth, Naturally Strong!"
  benefits={[
    <div key="vermi">
      <ul className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        {[
          {
            title: "Vermicompost",
            desc: "Nature’s fertilizer that boosts soil health and plant vitality.",
          },
          {
            title: "100% Natural & Organic",
            desc: "Free from chemicals — safe for soil, crops, and the environment.",
          },
          {
            title: "Improves Soil Fertility",
            desc: "Enriches with organic matter and boosts microbial activity.",
          },
          {
            title: "Enhances Plant Growth & Yield",
            desc: "Promotes stronger roots and higher productivity.",
          },
          {
            title: "Sustainable & Eco-Friendly",
            desc: "Supports green farming and soil health restoration.",
          },
          {
            title: "Moisture Retention & Aeration",
            desc: "Improves soil structure for better root development.",
          },
          {
            title: "Natural Pest & Disease Resistance",
            desc: "Protects plants using safe, eco-friendly methods.",
          },
          {
            title: "Versatile Applications",
            desc: "Ideal for vegetables, fruits, horticulture, and hydroponics.",
          },
        ].map((item, i) => (
          <li key={i} className="flex items-start space-x-3 text-[#f5e9e1]">
            <FaCheckCircle className="text-[#f7ebd0] text-lg mt-1 flex-shrink-0" />
            <div>
              <p className="font-semibold text-white">{item.title}</p>
              <p className="text-sm opacity-90">{item.desc}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>,
  ]}
/>

      <Collection />
      {/* <OurAchievements /> */}
<Benefits
  image={PowderImage}
  imageAlt="Powder Products"
  imagePosition="left"
  heading="🌿 Glow & Care – Naturally with Henna (Lawsonia Inermis) & Multani Mitti (Fuller’s Earth)"
  benefits={[
    <div key="henna">
      <strong className="text-2xl text-[#f7ebd0]">Henna (Lawsonia Inermis)</strong>
      <ul className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        {[
          {
            title: "Natural Hair Color",
            desc: "Safe, chemical-free coloring for a rich, natural tone.",
          },
          {
            title: "Strengthens Hair Roots",
            desc: "Reduces hair fall and dandruff while nourishing the scalp.",
          },
          {
            title: "Cooling & Soothing",
            desc: "Calms scalp irritation and refreshes naturally.",
          },
          {
            title: "Adds Shine & Volume",
            desc: "Promotes healthy, lustrous, and voluminous hair.",
          },
        ].map((item, i) => (
          <li key={i} className="flex items-start space-x-3 text-[#f5e9e1]">
            <FaCheckCircle className="text-[#f7ebd0] text-lg mt-1 flex-shrink-0" />
            <div>
              <p className="font-semibold text-white">{item.title}</p>
              <p className="text-sm opacity-90">{item.desc}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>,

    <div key="multani" className="mt-8">
      <strong className="text-2xl text-[#f7ebd0]">Multani Mitti (Fuller’s Earth)</strong>
      <ul className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        {[
          {
            title: "Deep Cleansing",
            desc: "Removes dirt, oil, and impurities for clearer skin.",
          },
          {
            title: "Improves Skin Texture",
            desc: "Leaves your skin smooth, soft, and radiant.",
          },
          {
            title: "Acne & Pimple Care",
            desc: "Controls excess oil and reduces breakouts naturally.",
          },
          {
            title: "Natural Skin Brightener",
            desc: "Restores a healthy, natural glow to the skin.",
          },
        ].map((item, i) => (
          <li key={i} className="flex items-start space-x-3 text-[#f5e9e1]">
            <FaCheckCircle className="text-[#f7ebd0] text-lg mt-1 flex-shrink-0" />
            <div>
              <p className="font-semibold text-white">{item.title}</p>
              <p className="text-sm opacity-90">{item.desc}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>,
  ]}
/>



      <WhyChooseUs />
      <OurSuccess />

      <Testimonials />
      <MarqueeFlags />

      {/* <ProductCategories /> */}
      {/* <FreshArrivals />
      <SuccessStory />
      <OurCollection />
      <CountryFlags />
      <SpecialDiscount />
      <Testimonials />
      <LatestArticles /> */}
      {/* <Features /> */}
    </>
  );
};

export default Home;
